import { QueryFactory } from "../../../../Common";
import { RC } from "../../../../Contracts";
export const QSaveSettings = QueryFactory(RC.QueryTypes.SaveSettings);
//# sourceMappingURL=QSaveSettings.js.map